import cookieHandler from "AtomicUtils/cookieHandler"

export const gtmEventTypes = {
  SUBMIT_LOGIN: "FED-MYMAZDA-001",
  FAIL_LOGIN: "FED-MYMAZDA-002",
  ENTER_EMAIL: "FED-MYMAZDA_ENTER_EMAIL",
  ENTER_PASSWORD: "FED-MYMAZDA_ENTER_PASSWORD",
  LOGIN: "LOGIN",
  PERSIST_LOGIN: "PERSIST_LOGIN",
  RESET_PASSWORD: "RESET_PASSWORD"
}

export const gtmEvents = {
  [gtmEventTypes.SUBMIT_LOGIN]: ({
    isVin
  }) => ({
    type: gtmEventTypes.SUBMIT_LOGIN,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: gtmEventTypes.SUBMIT_LOGIN,
    pageCategory: "MyMazda",
    pageAction: `MyMazda Login - Enter VIN/Rego - Submitted "${isVin ? "VIN" : "REGO"}"`
  }),
  [gtmEventTypes.FAIL_LOGIN]: ({
    isVin
  }) => ({
    type: gtmEventTypes.FAIL_LOGIN,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: gtmEventTypes.FAIL_LOGIN,
    pageCategory: "MyMazda",
    pageAction: `MyMazda Login - Enter VIN/Rego - Failed Login "${isVin ? "VIN" : "REGO"}"`
  }),
  [gtmEventTypes.ENTER_EMAIL]: () => ({
    type: gtmEventTypes.ENTER_EMAIL,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: gtmEventTypes.ENTER_EMAIL,
    pageCategory: "MyMazda Login Form",
    pageAction: "MyMazda Login Form - Entered \"EMAIL\""
  }),
  [gtmEventTypes.ENTER_PASSWORD]: () => ({
    type: gtmEventTypes.ENTER_PASSWORD,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: gtmEventTypes.ENTER_PASSWORD,
    pageCategory: "MyMazda Login Form",
    pageAction: "MyMazda Login Form - Entered \"PASSWORD\""
  }),
  [gtmEventTypes.LOGIN]: () => ({
    type: gtmEventTypes.LOGIN,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: gtmEventTypes.LOGIN,
    pageCategory: "MyMazda Login Form",
    pageAction: "MyMazda Login Form - Login"
  }),
  [gtmEventTypes.LOGIN]: () => ({
    type: gtmEventTypes.LOGIN,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: gtmEventTypes.LOGIN,
    pageCategory: "MyMazda Login Form",
    pageAction: "MyMazda Login Form - checked \"Keep me logged in\""
  }),
  [gtmEventTypes.RESET_PASSWORD]: () => ({
    type: gtmEventTypes.RESET_PASSWORD,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: gtmEventTypes.RESET_PASSWORD,
    pageCategory: "MyMazda Forgot password Form",
    pageAction: "MyMazda Forgot password Form - Reset\""
  })
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/mymazda-login-duck.js